import type Stripe from 'stripe'

import type { ApiSuccess } from '../../../index.js'

export type Product = Stripe.Product

export type Price = Stripe.Price

export type PriceWithExpansions = Stripe.Price & { product: Stripe.Product }

export type ProductWithPrices = Stripe.Product & {
  prices: Stripe.Price[],
  isDefault?: boolean,
}

export type GetResponseBody = ApiSuccess<ProductWithPrices[]>

export enum PlanType {
  Starter = 'starter',
  Wizard = 'wizard',
  Dashboard = 'dashboard',
  Seal = 'seal',
}
